export const hiddenBreadcrumbs = [
    'company.administrators.list',
    'company.directory-integration.add-active-directory',
    'company.directory-integration.manage.connection',
    'company.directory-integration.manage.connection.ou-imported',
    'company.directory-integration.manage.domains',
    'company.directory-integration.manage.domains.add-domain',
    'company.directory-integration.manage.domains.delete-domain',
    'company.directory-integration.manage.domains.edit-domain',
    'company.directory-integration.manage.main',
    'company.directory-integration.manage.main.remove',
    'company.manage-application.configuration',
    'company.manage-application.dropbox-provisioning',
    'company.manage-application.integration-developers',
    'company.manage-application.integration-developers.app-key-password',
    'company.manage-application.integration-developers.configure-sso',
    'company.manage-application.integration-developers.help',
    'company.manage-application.integration-developers.integration',
    'company.manage-application.integration-developers.integration-office-365',
    'company.manage-application.integration-developers.manual-integration',
    'company.manage-application.integration-developers.non-domain-protection-key',
    'company.manage-application.integration-developers.remove-configuration',
    'company.manage-application.integration-developers.simulators',
    'company.manage-application.integration-developers.widgets',
    'company.manage-application.mobile-app-support',
    'company.manage-application.remove',
    'company.manage-application.roles',
    'company.manage-application.roles.add',
    'company.manage-application.roles.edit',
    'company.manage-application.usage-data',
    'company.manage-application.user-provisioning',
    'company.manage-application.users',
    'company.manage-application.users.assign-groups',
    'company.sms-services.help.how-to-add-sms-user',
    'company.sms-services.help.sms-credit',
    'company.sms-services.help.sms-settings',
    'company.sms-services.help.what-is-sms-service',
    'company.sms-services.invoice',
    'company.sms-services.paypal-cancelled',
    'company.sms-services.paypal-confirmed',
    'company.user-directories',
    'company.user-directories.directory-groups.all-accounts.copy',
    'company.user-directories.directory-groups.all-accounts.delete',
    'company.user-directories.directory-groups.all-accounts.export',
    'company.user-directories.directory-groups.all-accounts.verify',
    'company.user-directories.directory-groups.directory.add-new-group',
    'company.user-directories.directory-groups.directory.add-user',
    'company.user-directories.directory-groups.directory.import-users.upload-result',
    'company.user-directories.manage-account.change-owner',
    'company.user-directories.manage-account.details',
    'company.user-directories.manage-account.groups-apps',
    'company.user-directories.manage-account.groups-apps.add-to-groups',
    'company.user-directories.manage-account.profile-attributes',
    'company.user-directories.manage-account.profile-attributes.edit',
    'company.user-directories.manage-account.send-verification-email',
    'company.user-directories.manage-account.verify',
    'company.user-directories.manage-group.accounts',
    'company.user-directories.manage-group.accounts.add',
    'company.user-directories.manage-group.accounts.copy',
    'company.user-directories.manage-group.accounts.delete',
    'company.user-directories.manage-group.accounts.export',
    'company.user-directories.manage-group.accounts.import',
    'company.user-directories.manage-group.accounts.import.result',
    'company.user-directories.manage-group.accounts.move',
    'company.user-directories.manage-group.accounts.verify',
    'company.user-directories.manage-group.applications',
    'company.user-directories.manage-group.applications.assign',
    'company.user-directories.manage-group.settings',
    'company.user-directories.manage-user.add-account',
    'company.user-directories.manage-user.copy-accounts',
    'company.user-directories.manage-user.copy-shared-accounts',
    'company.user-directories.manage-user.delete-accounts',
    'company.user-directories.manage-user.details',
    'company.user-directories.manage-user.edit-display-name',
    'company.user-directories.manage-user.move-accounts',
    'company.user-directories.manage-user.move-shared-accounts',
    'company.user-directories.manage-user.remove-accounts',
];



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-breadcrumbs/hidden-breadcrumbs.js